import { MainSigninSection } from 'src/v2/pages/auth/components/MainSigninSection';
import { isEnterprise } from 'src/utils';
import { MainEmailSigninSection } from '../components/MainEmailSigninSection';
import { EnterpriseMeetNinjaSection } from 'src/v2/pages/auth/components/MeetNinjaSection';
import { useQueryParams } from 'src/hooks';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { SEO_LOGIN_DESCRIPTION, SEO_LOGIN_TITLE } from 'src/constants';
import { BaseSignPage } from '../BaseSignPage/BaseSignPage';
import { BasePublicPage } from 'src/v2/pages/auth/BasePublicPage';

export const SigninPage = () => {
  const {
    searchParams: { email_verified },
    removeSearchParam,
  } = useQueryParams();

  useEffect(() => {
    if (email_verified) {
      toast.success('Email verification successful');
      removeSearchParam('email_verified');
    }
  }, [email_verified, removeSearchParam]);

  return isEnterprise ? (
    <BasePublicPage
      seoTitle={SEO_LOGIN_TITLE}
      seoDescription={SEO_LOGIN_DESCRIPTION}
    >
      <EnterpriseMeetNinjaSection />
      <MainEmailSigninSection />
    </BasePublicPage>
  ) : (
    <BaseSignPage
      seoTitle={SEO_LOGIN_TITLE}
      seoDescription={SEO_LOGIN_DESCRIPTION}
    >
      <MainSigninSection />
    </BaseSignPage>
  );
};
